/* Luvlyn · voorwaarden (port van js/voorwaarden.js uit het ontwerp, 04-10-2026). Alleen variant A, één lange
   pagina: de meelopende inhoudsopgave licht het stuk op dat nu in beeld is. Naar een document of het
   modelformulier springen (#privacy, #herroeping, #modelformulier) doet de browser zelf: het zijn gewone ids,
   met scroll-margin-top onder de meelopende kop (assets/vw.css). */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const zacht = matchMedia('(prefers-reduced-motion: reduce)').matches;

  $$('[data-vw-inhoud]').forEach(nav => {
    if (!('IntersectionObserver' in window)) return;
    const box = nav.closest('.variant');
    const koppen = $$('[data-spy]', box);
    const linkVan = el => el.dataset.spyDoc ? $(`a[data-spy-link="${el.dataset.spyDoc}"]`, nav) : $(`a[href="#${el.id}"]`, nav);
    // welk stuk is nu aan de beurt: de laatste kop die de bovenkant (onder de meelopende kop) voorbij is
    function werkBij(){
      let nu = koppen[0];
      for (const k of koppen) { if (k.getBoundingClientRect().top <= 150) nu = k; else break; }
      const a = nu && linkVan(nu);
      if (!a || a.classList.contains('nu')) return;
      $$('a.nu', nav).forEach(x => x.classList.remove('nu'));
      a.classList.add('nu');
      // de inhoudsopgave zelf schuift mee als hij hoger is dan het scherm
      const r = a.getBoundingClientRect(), n = nav.getBoundingClientRect();
      if (r.top < n.top || r.bottom > n.bottom) nav.scrollTo({ top: nav.scrollTop + r.top - n.top - n.height / 3, behavior: zacht ? 'auto' : 'smooth' });
    }
    // de waarnemer is alleen het seintje dat er een kop over de rand gaat; geen scroll-listener
    const zie = new IntersectionObserver(() => werkBij(), { rootMargin: '-140px 0px -40% 0px', threshold: [0, 1] });
    koppen.forEach(el => zie.observe(el));
    werkBij();
  });
})();
